import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"

export function useCompanySearch(search?: string) {
	return useQuery({
		queryKey: ["companies", "search", search ?? ""],
		queryFn: () =>
			GET("/api/v1/companies/search", {
				params: { query: { search: search! } },
			}),
		enabled: !!search,
		placeholderData: keepPreviousData,
	})
}
